import axios from '@/app/axios'
import Responses from '@/app/utils/responses'
import Keyword from '@/common/models/keyword'
import { KeywordType } from '@/diagrams/models/keyword-type'
import nodesService from '@/diagrams/services/nodes-service'
import Topic from '@/diagrams/models/topic'
import SpiderData from '@/diagrams/models/spider-data'

class DiagramService {

  public async spider(projectId: string, action: string) {
    const url = `DiagramView/${action}`
    const res = await axios.get<SpiderData>(url, {
      params: {
        id: projectId,
      },
    })
    return Responses.obj(res)
  }

  public async matrix(projectId: string, action: string) {
    const url = `DiagramView/${action}`
    const res = await axios.get<any>(url, {
      params: {
        id: projectId,
      },
    })
    return Responses.list(res)
  }

  public async timeline(projectId: string, action: string): Promise<any> {
    const url = `DiagramView/${action}`
    const res = await axios.get<any>(url, {
      params: {
        id: projectId,
      },
    })
    return Responses.list(res)
  }

  public async getStakeHolderGroups(idParam: string) {
    const url = `DiagramView/stakeholderGroups`
    const res = await axios.get<any>(url,
      {
        params: {
          id: idParam,
        },
      },
    )
    return Responses.list(res)
  }

  public async topicGroupUpdateMembers(idParam: string, topicIds: string[]) {
    const url = `TopicGroup/updateMembers`

    const res = await axios.post<any>(url, {
      topicGroupId: idParam,
      topicIds,
    })

    return Responses.list(res)
  }

  public async topicGroupCreateMember(idParam: string, topicId: string) {
    const url = `TopicGroup/createMember`

    const res = await axios.post<any>(url, {
      topicGroupId: idParam,
      topicId,
    })

    return Responses.list(res)
  }

  public async getKeywords(type: KeywordType, text: string = '') {
    const res = await axios.post<Keyword[]>('keyword', { text, type })
    return Responses.list(res)
  }

  public async createKeyword(value: any) {
    if (value == null) {
      return
    }
    const res = await axios.post<Keyword[]>('keyword/create', {
      name: value.text,
      type: value.type,
    })
    return Responses.list(res)
  }

  public async updateTopic(val: Topic) {
    const url = `Topic/update`
    const res = await axios.put<Topic>(url, val)
    return Responses.obj(res)
  }

  public async toggleTopicActivity(id: string | null, active: boolean) {
    if (id == null) {
      return null
    }
    const topic = await nodesService.findOneAsync<Topic>('Topic', id)
    if (topic) {
      topic.isActive = active
      await this.updateTopic(topic)
    }
  }

  public async deleteNode(className: NodeClassName, id: string | null) {
    if (id == null) {
      return null
    }
    const res = await nodesService.deleteOneAsync(className, id)
    return res
  }

}

export default new DiagramService()
